exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".hwrld.S_kiyraPRWXkiPLZpaZF4 {\n  border: 1px solid #00BCE4;\n  border-radius: 4px;\n  position: relative;\n  display: inline-block;\n  width: 30px;\n  height: 30px;\n  overflow: hidden;\n  cursor: pointer;\n}\n.hwrld.S_kiyraPRWXkiPLZpaZF4::before, .hwrld.S_kiyraPRWXkiPLZpaZF4::after {\n  content: \"\";\n  position: absolute;\n  background: #00BCE4;\n}\n.hwrld.S_kiyraPRWXkiPLZpaZF4::before {\n  height: 4px;\n  left: 6px;\n  top: 12px;\n  width: 16px;\n}\n.hwrld.S_kiyraPRWXkiPLZpaZF4._3-10qHju8Jb85Kr7LEjent::after {\n  height: 16px;\n  left: 12px;\n  top: 6px;\n  width: 4px;\n}", ""]);

// exports
exports.locals = {
	"hwrld": "S_kiyraPRWXkiPLZpaZF4",
	"plus": "_3-10qHju8Jb85Kr7LEjent"
};